import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { BdFeatureStatusMaintenanceComponent } from './feature-status.component';
import { BdFeatureStatusGuard } from '@bindoc-projects/security-lib/data';

export const BD_FEATURE_STATUS_PATH = 'sys-feature-maintenance';
export const BD_FEATURE_STATUS_ROUTE: Route = {
  path: BD_FEATURE_STATUS_PATH,
  component: BdFeatureStatusMaintenanceComponent,
};

@NgModule({
  imports: [
    RouterModule.forChild([BD_FEATURE_STATUS_ROUTE]),
    BdFeatureStatusMaintenanceComponent,
  ],
  exports: [RouterModule, BdFeatureStatusMaintenanceComponent],
  providers: [BdFeatureStatusGuard],
})
export class BdFeatureStatusModule {}
